import { Component, ReactNode } from "react";
type Props = { children: ReactNode };
type State = { hasError: boolean };
export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };
  static getDerivedStateFromError() { return { hasError: true }; }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6">
          <div className="max-w-md text-center">
            <h2 className="text-2xl font-semibold">Ops! Algo deu errado.</h2>
            <p className="mt-2 opacity-70">Tente atualizar a página.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
